"use strict";

var BreadCrumbsDropdown = function () {
  var setDropdown = function (pageName = null) {
    if (pageName === null) {
      _setToolDropdown();
    } else {
      _setToolLink(pageName);
    }
  };

  var _setToolLink = function (pageName) {
    const displayName = PageFunctions.getPageConfigByPageName(pageName).displayName;
    const isRegulator = Progeny.rootGroupIsRegulator();

    $("#bread-crumbs-dropdown").html(
      nunjucks.render("report/navbar/toolLink.njk", { pageName, displayName, isRegulator }),
    );
  };

  var _setToolDropdown = function () {
    const toolDropdownItems = Panels.getToolDropdownItems();

    $("#bread-crumbs-dropdown").html(nunjucks.render("report/navbar/toolDropdown.njk"));
    $("#tool-dropdown").html(Panels.getToolDropdownHtml(toolDropdownItems));
  };

  return { setDropdown };
};

module.exports = BreadCrumbsDropdown();

const Panels = require("../panels");
const PageFunctions = require("./pageFunctions");
const Progeny = require("../login/progeny");
